import { render, staticRenderFns } from "./page-no-access.vue?vue&type=template&id=786d57c0&scoped=true"
import script from "./page-no-access.vue?vue&type=script&lang=js"
export * from "./page-no-access.vue?vue&type=script&lang=js"
import style0 from "./page-no-access.vue?vue&type=style&index=0&id=786d57c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d57c0",
  null
  
)

export default component.exports